class RecentlyViewed extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.dataset.recentlyViewed) return

    this.setRecentlyViewed()
  }

  async setRecentlyViewed () {
    await window.BAO.Cart.updateCartAttributes({
      recently_viewed_products: `${this.dataset.recentlyViewed}`,
    })
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed)
}
